<template>
  <div>
    <ListWrapper
      ref="listWrapperReference"
      :url="url"
      :addButtonText="$lang.new_history"
      @getPermissions="getPermissions"
      @handleAddButton="showAddPin"
    >
      <template slot-scope="{ items }">
        <WhatsNewCards :items="items" :permissions="permissions" />
      </template>
    </ListWrapper>
    <WhatsNewAddPin
      :visible="addPin"
      :permissions="permissions"
      @reload="listWrapperReload"
      @close="closeAddPin"
    />
  </div>
</template>

<script>
import ListWrapper from "@/components/re-design/lists/ListWrapper.vue";
import WhatsNewCards from "./components/WhatsNewCards.vue";
import WhatsNewAddPin from "./components/WhatsNewAddPin.vue";
import { generateApiUrl } from "@/shared/utils";
import { computed, ref } from "vue";

export default {
  components: { ListWrapper, WhatsNewCards, WhatsNewAddPin },
  setup() {
    const url = computed(() => generateApiUrl(["profile", "whats_new"]));
    const permissions = ref([]);
    const getPermissions = (value) => (permissions.value = [...value]);

    // add data
    let addPin = ref(false);
    const showAddPin = () => {
      addPin.value = true;
    };
    const closeAddPin = () => {
      addPin.value = false;
    };

    // reload list with reference
    const listWrapperReference = ref(null);
    const listWrapperReload = () => {
      listWrapperReference.value.reload();
    };

    return {
      url,
      permissions,
      getPermissions,
      addPin,
      showAddPin,
      closeAddPin,
      listWrapperReference,
      listWrapperReload,
    };
  },
};
</script>
